// extracted by mini-css-extract-plugin
export default {"content":"hiring-manager-modal_content__C-EHI patterns_scrollBody__ksWzg"};